export type ClauseAcceptance = 'singleAcceptance' | 'multipleAcceptance';
export type ClauseAcceptanceDTO = 'single_acceptance' | 'multiple_acceptance';

export const CLAUSE_ACCEPTANCE: { [key in ClauseAcceptance]: ClauseAcceptanceDTO } = {
  singleAcceptance: 'single_acceptance',
  multipleAcceptance: 'multiple_acceptance',
};
